/* eslint-disable default-param-last */
import { EntityType } from '../../types/enums';
import { Action } from '../types/types';
import type { LivekitIngress, LivekitState } from '../types/livekit';

export const initialLivekitState: LivekitState = {
	livekitSession: null,
	livekitIngresses: [],
};

const actions: Map<string, Function> = new Map([
	[
		EntityType.livekitSession,
		(state: LivekitState, action: Action): LivekitState => ({
			...state,
			livekitSession: action.payload?.entityValue ?? null,
		}),
	],
	[
		EntityType.livekitIngress,
		(state: LivekitState, action: Action): LivekitState => {
			const ingress: LivekitIngress = action.payload?.entityValue;
			if (!ingress) return state;
			const others = state.livekitIngresses.filter((i) => i.id !== ingress.id);
			return { ...state, livekitIngresses: [...others, ingress] };
		},
	],
	[
		`${EntityType.livekitIngress}-delete`,
		(state: LivekitState, action: Action): LivekitState => {
			const ingressId = action.payload?.entityValue?.id;
			return {
				...state,
				livekitIngresses: state.livekitIngresses.filter((i) => i.id !== ingressId),
			};
		},
	],
]);

export function LivekitReducer(state: LivekitState = initialLivekitState, action: Action): LivekitState {
	return actions.get(action.type)?.(state, action) ?? state;
}
